import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { compose } from 'redux';

import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { Field, fieldArrayPropTypes } from 'redux-form';
import s from './MultipleSignersFormField.scss';
import SkholeIcon17 from '../../statelessComponents/Icons/SkholeIcon17';
import SkholeIcon13 from '../../statelessComponents/Icons/SkholeIcon13';
import TextField from '../../statelessComponents/FormFields/TextField';

const messages = defineMessages({
  deleteSignerLabel: {
    id: 'MultipleSignersFormField.deleteSignerLabel',
    defaultMessage: 'Delete signer',
  },
  addNewSignerLabel: {
    id: 'MultipleSignersFormField.addNewSignerLabel',
    defaultMessage: 'Add new signer',
  },
  nameLabel: {
    id: 'MultipleSignersFormField.nameLabel',
    defaultMessage: 'Signer {index}',
  },
});

const MultipleSignersFormField = (
  { fields, meta, disabled, intl: { formatMessage }, maxSignersAmount }, // eslint-disable-line
) => (
  <div className={s.subtitlesContainer}>
    {fields.map((signerEmail, index) => (
      <div className={s.marginTop} key={`signerEmail-${signerEmail}`}>
        <div className={s.subtitleRow}>
          <Field
            name={`${signerEmail}`}
            type="text"
            label={formatMessage(messages.nameLabel, { index: index + 1 })}
            margin="normal"
            component={TextField}
            disabled={disabled}
            fullWidth
            multiline
          />

          {!disabled && (
            <Tooltip
              title={formatMessage(messages.deleteSignerLabel)}
              enterDelay={200}
            >
              <Button
                data-test-id="6q6yVRFMK9nmQ_MxpMa5Y"
                onClick={() => fields.remove(index)}
                style={{
                  backgroundColor: 'transparent',
                }}
                className={s.deleteSubtitleBtn}
              >
                <SkholeIcon13 />
              </Button>
            </Tooltip>
          )}
          {meta.error && meta.invalid && <span>{meta.error}</span>}
        </div>
      </div>
    ))}
    {!disabled && (
      <div className={s.addNewSubtitle}>
        <Tooltip
          title={formatMessage(messages.addNewSignerLabel)}
          enterDelay={200}
        >
          <Button
            data-test-id="pU4cXdw8z7ZOIiRSmKzN9"
            className={s.addNewBtn}
            onClick={() => fields.push('')}
            data-test="add-new-signer-button"
            disabled={fields.length >= maxSignersAmount}
          >
            <SkholeIcon17 className={s.addIcon} />
            <FormattedMessage {...messages.addNewSignerLabel} />
          </Button>
        </Tooltip>
      </div>
    )}
  </div>
);

MultipleSignersFormField.propTypes = {
  ...fieldArrayPropTypes,
};

export default compose(withStyles(s), injectIntl)(MultipleSignersFormField);
